import React, { useRef, useState } from "react";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { PhoneInput } from "react-international-phone";
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { SacpcmpLookup, consultantAdd, consultantUpdate } from "../../service/consultantService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { InputIcon } from "primereact/inputicon";
import MultiDropdownApi from "../../components/MultiDropdownApi";

export default function ConsultantsAdd(modalProps: any) {

  const record = modalProps.record || {};

  const [name, setName] = useState(record?.name || "");
  const [industry, setIndustry] = useState(record?.industry || 0);
  const [nameError, setNameError] = useState(false);
  const [adminName, setAdminName] = useState(record?.admin_name || "");
  const [adminNameError, setAdminNameError] = useState(false);
  const [adminSurname, setAdminSurname] = useState(record?.admin_surname || "");
  const [adminSurnameError, setAdminSurnameError] = useState(false);
  const [adminMobile, setAdminMobile] = useState(record?.admin_mobile || "");
  const [adminEmail, setAdminEmail] = useState(record?.admin_email || "");
  const [sacpcmpId, setSacpcmpId] = useState(record?.sacpcmp_id || "");
  const [sacpcmpShowValidation, setSacpcmpShowValidation] = useState(false);
  const [sacpcmpIdError, setSacpcmpIdError] = useState(false);
  const [sacpcmpIdLoader, setSacpcmpIdLoader] = useState(false);
  const [adminEmailError, setAdminEmailError] = useState(false);
  const [userId, setUserId] = useState(record?.user_id || '');

  async function addConsultant() {
    const errorAdminName = !adminName || adminName === '';
    const errorAdminSurname = !adminSurname || adminSurname === '';
    const errorAdminEmail = !adminEmail || adminEmail === '';
    setAdminNameError(errorAdminName);
    setAdminSurnameError(errorAdminSurname);
    setAdminEmailError(errorAdminEmail);
    if (errorAdminName || errorAdminSurname || errorAdminEmail) {
      modalProps.toast.current.show({ severity: 'warn', summary: 'Please enter all required fields', life: 3000 });
      return;
    }
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      consultantUpdate({
        name: name || `${adminName} ${adminSurname}`,
        admin_name: adminName,
        admin_surname: adminSurname,
        admin_mobile: adminMobile,
        admin_email: adminEmail,
        sacpcmp_id: sacpcmpId,
        industry,
        user_id: userId
      }, record?.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'Consultant Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setReload(!modalProps.reload);
      });
      return;
    }
    consultantAdd({
      name: name || `${adminName} ${adminSurname}`,
      admin_name: adminName,
      admin_surname: adminSurname,
      admin_mobile: adminMobile,
      admin_email: adminEmail,
      sacpcmp_id: sacpcmpId,
      industry
    }).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({ severity: 'success', summary: 'Consultant Created Successfully', life: 3000 });
      modalProps.setVisible(false);
      modalProps.setReload(!modalProps.reload);
    })
  }

  async function SacpcmpVerifyID() {
    if (!sacpcmpId) return;
    setSacpcmpIdLoader(true);
    setSacpcmpShowValidation(true);
    console.log("== SacpcmpVerifyID == ");
    SacpcmpLookup(sacpcmpId).then((r: any) => {
      console.log("SacpcmpVerifyID r == ", r);
      setSacpcmpIdLoader(false);
      if (!r?.sacpcmp_membership_number) {
        setSacpcmpIdError(true);
        return;
      }
      const fullNameSplit: string[] = r.sacpcmp_full_name.split(' ');
      setAdminName(fullNameSplit.splice(0, 1)[0]);
      setAdminSurname(fullNameSplit.join(' '));
      setSacpcmpIdError(false);
    }).catch((error) => {
      setSacpcmpIdLoader(false);
      setSacpcmpIdError(true);
    });
  }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Company Name</FormLabel>
            <FormControl
              error={nameError}
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Company Name" value={name} onChange={e => setName(e.target.value)} />
            </FormControl>
          </Stack>
          <Stack spacing={1}>
            <FormLabel>SACPCMP ID <a style={{ marginLeft: 15 }} href="https://search.mymembership.co.za/Search/?Id=e32e242a-44bd-475d-9e98-53a9fbbd2caf" target="_blank">Search</a></FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="SACPCMP ID" value={sacpcmpId} onChange={e => setSacpcmpId(e.target.value)} onBlur={SacpcmpVerifyID}
                endDecorator={
                  sacpcmpIdLoader ? <InputIcon className="pi pi-spin pi-spinner" /> : !sacpcmpShowValidation ? '' :
                    sacpcmpIdError ? <InputIcon className="pi pi-times-circle" style={{ color: 'red' }} /> : <InputIcon className="pi pi-verified" style={{ color: 'green' }} />
                } />
            </FormControl>
          </Stack>
          <Stack spacing={1}>
            <MultiDropdownApi required={true} apiPath='industry' optionLabel="name" optionValue='id' label='Industry' selectedData={industry} setSelectedData={setIndustry} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <FormControl
              error={adminNameError}
              style={{ width: '45%' }}>
              <FormLabel>Name <div style={{ color: 'red' }}>*</div></FormLabel>
              <Input
                size="sm"
                placeholder="Name"
                value={adminName}
                onChange={e => setAdminName(e.target.value)}
                sx={{ flexGrow: 1 }}
              />
            </FormControl>
            <FormControl
              error={adminSurnameError}
              style={{ width: '45%' }} sx={{ flexGrow: 1 }}>
              <FormLabel>Surname <div style={{ color: 'red' }}>*</div></FormLabel>
              <Input
                size="sm"
                placeholder="Surname"
                value={adminSurname}
                onChange={e => setAdminSurname(e.target.value)}
                sx={{ flexGrow: 1 }}
              />
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2}>
            <FormControl style={{ width: '45%' }}>
              <FormLabel>Mobile</FormLabel>
              <PhoneInput
                defaultCountry="za"
                value={adminMobile}
                style={{ width: '100%' }}
                onChange={e => setAdminMobile(e)}
              />
            </FormControl>
            <FormControl
              error={adminEmailError}
              style={{ width: '45%' }} sx={{ flexGrow: 1 }}>
              <FormLabel>Email<div style={{ color: 'red' }}>*</div></FormLabel>
              <Input
                size="sm"
                type="email"
                startDecorator={<EmailRoundedIcon />}
                placeholder="email"
                value={adminEmail}
                onChange={e => setAdminEmail(e.target.value)}
                sx={{ flexGrow: 1 }}
              />
            </FormControl>
          </Stack>
          {/* <div>1
                <CountrySelector />
              </div> */}
        </Stack>
      </Stack>
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => addConsultant()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}